<div class="body-container">
  <div class="info-container">
    Vous n'êtes pas autorisé à participer à cette session.
  </div>
</div>
